import Input from 'components/Input';
import Select from 'components/Select';
import React, { useState } from 'react';
import { Button, Modal } from "react-bootstrap";
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { createEarningCode } from 'services/earningCodes';

const EARNING_TYPE_OPTIONS = [
    { value: 'Regular', label: 'Regular' },
    { value: 'Overtime', label: 'Overtime' },
    { value: 'DoubleOvertime', label: 'Double Overtime' },
    { value: 'Holiday', label: 'Holiday' },
    { value: 'PTO', label: 'PTO' },
    { value: 'Sick', label: 'Sick' },
    { value: 'Bonus', label: 'Bonus' },
    { value: 'Commission', label: 'Commission' },
    { value: 'Reimbursement', label: 'Reimbursement' },
    { value: 'Severance', label: 'Severance' },
    { value: 'Other', label: 'Other' },
];

const initialForm = {
    name: '',
    type: '',
};

function AddEarningCodeModal({ open, onClose }) {
    const [form, setForm] = useState(initialForm);
    const [errors, setErrors] = useState({});
    const queryClient = useQueryClient();

    const mutation = useMutation({
        mutationFn: createEarningCode,
        onSuccess: (newCode) => {
            queryClient.setQueryData(['earning-codes'], (old = []) => [...old, newCode]);
            setForm(initialForm);
            setErrors({});
            onClose();
        },
    });

    const handleChange = (e) => {
        const { name, value } = e.target;
        setForm(prev => ({ ...prev, [name]: value }));
        if (errors[name]) setErrors(prev => ({ ...prev, [name]: '' }));
    };

    const validate = () => {
        const newErrors = {};
        if (!form.name.trim()) newErrors.name = 'Name is required.';
        if (!form.type) newErrors.type = 'Earning type is required.';
        return newErrors;
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        const newErrors = validate();
        if (Object.keys(newErrors).length > 0) {
            setErrors(newErrors);
            return;
        }
        mutation.mutate({
            name: form.name,
            type: form.type,
            active: true,
        });
    };

    const handleClose = () => {
        setForm(initialForm);
        setErrors({});
        mutation.reset();
        onClose();
    };

    return (
        <Modal className='add-workplace-modal' show={open} onHide={handleClose} centered>
            <div className="modal-header border-0 pb-0 d-flex justify-content-between align-items-center">
                <h4 className="sub-title text-black mb-0">Add Earning Code</h4>
                <button type="button" className="close bg-transparent border-0" onClick={handleClose}>
                    <span aria-hidden="true">&times;</span>
                </button>
            </div>
            <Modal.Body className='pt-0'>
                <form onSubmit={handleSubmit}>
                    <div>
                        <h2 className='sub-title workplace-information-title mb-0'>General Information</h2>
                        <div className='row mt-4'>
                            <div className='col-12'>
                                <label>Name*</label>
                                <Input
                                    fullWidth
                                    variant='flat'
                                    placeholder='Enter Name'
                                    name='name'
                                    value={form.name}
                                    onChange={handleChange}
                                    error={!!errors.name}
                                    errorText={errors.name}
                                />
                            </div>
                            <div className='col-12 mt-4'>
                                <label>Earning Type*</label>
                                <Select
                                    fullWidth
                                    placeholder='Select Type'
                                    options={EARNING_TYPE_OPTIONS}
                                    name='type'
                                    value={form.type}
                                    onChange={handleChange}
                                    error={!!errors.type}
                                    errorText={errors.type}
                                />
                            </div>
                        </div>
                    </div>
                    {mutation.isError && (
                        <p className="text-danger mt-3">
                            {mutation.error?.response?.data?.message || mutation.error?.response?.data?.title || 'Failed to add earning code. Please try again.'}
                        </p>
                    )}
                    <Modal.Footer className='border-0 justify-content-start px-0 mb-5'>
                        <Button type='submit' className='button-orange' disabled={mutation.isPending}>
                            {mutation.isPending ? 'Saving...' : 'Add Earning Code'}
                        </Button>
                    </Modal.Footer>
                </form>
            </Modal.Body>
        </Modal>
    );
}

export default AddEarningCodeModal;

